import useGlobale from "../components/global";
import Navbar from "../components/accueil/Navbar";
import HeroSection from "../components/accueil/HeroSection";
import ServicesSection from "../components/accueil/ServicesSection";
import DestinationsSection from "../components/accueil/DestinationsSection";
import HotelsSection from "../components/accueil/HotelsSection";
import WhyTraceSection from "../components/accueil/WhyTraceSection";
import InfoImportante from "../components/accueil/InfoImportante";
import Newsletter from "../components/accueil/Newsletter";
import Footer from "../components/accueil/Footer";
import ChatWidget from "../components/accueil/ChatWidget";
import BackToTop from "../components/accueil/BackToTop";

export default function AccueilPage() {
  const { authenticated, user, logout } = useGlobale();

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <Navbar authenticated={authenticated} user={user} logout={logout} />
      <HeroSection />
      <ServicesSection />
      <DestinationsSection />
      <HotelsSection />
      <WhyTraceSection />
      <InfoImportante />
      <Newsletter />
      <Footer />
      <ChatWidget />
      <BackToTop />
    </div>
  );
}
